/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssessmentControllerGetComparisonReport200ResponseData } from './assessmentControllerGetComparisonReport200ResponseData';


export interface AssessmentControllerGetComparisonReport200Response { 
    statusCode?: number;
    success?: boolean;
    message?: string;
    data?: AssessmentControllerGetComparisonReport200ResponseData;
}

